// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var FeedbackSuccessModalPhase = function (x) {
    return x;
};
var tsBridgeFeedbackSuccessMo = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeIntersection([ new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("hidden"), new DTS_Types.TsTypeTypelevelString("visible") ]), new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("__brandFeedbackSuccessModalPhase", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString("FeedbackSuccessModalPhase")) ]) ]));
    }
};
var showFeedbackSuccessModalPhase = Data_Show.showString;
var ordFeedbackSuccessModalPhase = Data_Ord.ordString;
var feedbackSuccessModalPhaseVisible = "visible";
var feedbackSuccessModalPhaseToString = function (v) {
    return v;
};
var writeFeedbackSuccessModalPhase = {
    writeImpl: /* #__PURE__ */ (function () {
        var $19 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($20) {
            return $19(feedbackSuccessModalPhaseToString($20));
        };
    })()
};
var feedbackSuccessModalPhaseHidden = "hidden";
var feedbackSuccessModalPhaseNamespace = {
    hidden: feedbackSuccessModalPhaseHidden,
    visible: feedbackSuccessModalPhaseVisible
};
var feedbackSuccessModalPhaseFromString = function (value) {
    if (value === "hidden") {
        return new Data_Maybe.Just(feedbackSuccessModalPhaseHidden);
    };
    if (value === "visible") {
        return new Data_Maybe.Just(feedbackSuccessModalPhaseVisible);
    };
    return Data_Maybe.Nothing.value;
};
var readFeedbackSuccessModalPhase = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = feedbackSuccessModalPhaseFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid FeedbackSuccessModalPhase: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Ui.FeedbackSuccessModalPhase (line 54, column 5 - line 56, column 92): " + [ v.constructor.name ]);
        });
    }
};
var eqFeedbackSuccessModalPhase = Data_Eq.eqString;
export {
    feedbackSuccessModalPhaseHidden,
    feedbackSuccessModalPhaseVisible,
    feedbackSuccessModalPhaseNamespace,
    feedbackSuccessModalPhaseFromString,
    feedbackSuccessModalPhaseToString,
    eqFeedbackSuccessModalPhase,
    ordFeedbackSuccessModalPhase,
    showFeedbackSuccessModalPhase,
    readFeedbackSuccessModalPhase,
    writeFeedbackSuccessModalPhase,
    tsBridgeFeedbackSuccessMo
};
//# sourceMappingURL=index.js.map
